export const START_MISSIONS = "START_MISSIONS";
export const MISSIONS_SUCCESS = "MISSIONS_SUCCESS";
export const MISSIONS_FAIL = "MISSIONS_FAIL";

export const START_MISSION_BY_USER = "START_MISSION_BY_USER"
export const SUCCESS_MISSION_BY_USER = "SUCCESS_MISSION_BY_USER"
export const FAIL_MISSION_BY_USER = "FAIL_MISSION_BY_USER"
